import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeContextProvider from "./contexts/ThemeContext";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

ReactDOM.render(
  <ThemeContextProvider>
    <App />
  </ThemeContextProvider>,
  document.getElementById("root")
);

reportWebVitals();

// let args = [
//   "%c %c :stha-bikash  %c " +
//     " %c %c " +
//     " https://www.stha-bikash.com..np/  %c # \n\n",
//   // "background:rgb(27, 168, 44); padding:5px 0;",
//   "background: rgb(27, 152, 56); padding:5px 0;",
//   "color: #f14e2e; background: #030307; padding:5px 0;",
//   "background: rgb(237, 236, 243); padding:5px 0;",
//   "background: rgba(55, 169, 82, 0); padding:15px 0; color: transparent;",
//   "background: rgb(20, 160, 50); padding:5px 0;",
//   "color: #ffffff; background:rgb(93, 0, 255); padding:5px 0;",
// ];

// console.log.apply(console, args);
